<template>
  <div class="sc-table">
    <div class="title">
      <img src="@/assets/圆圈.png" alt />
      <div>全国销售信息</div>
    </div>

    <div class="subtitle">
      <span class="statistics-date">销售时间</span>
      <el-date-picker v-model="date" type="date" placeholder="选择日期" :picker-options="pickerOptions"></el-date-picker>
      <el-button type="primary" class="button" @click="onQuery">查询</el-button>

      <div class="sc-table-header-right">
        <div
          class="update-date"
          v-if="latestUpdateDate"
        >最近更新时间：{{util.toDateString(latestUpdateDate)}}</div>
        <div class="tips">
          <img src="@/assets/？.png" />
          <span>统计方式是单日销售数据，选择销售日期可查询一月内当日销售数据</span>
        </div>
      </div>
    </div>

    <el-table
      v-loading="loading"
      :data="retrieve.results"
      stripe
      style="width: 100%"
      header-cell-class-name="my-header-cell"
      header-row-class-name="my-header-row"
      row-class-name="my-row"
      cell-class-name="my-cell"
    >
      <el-table-column prop="code" label="商品编码" width="70"></el-table-column>
      <el-table-column prop="name" label="商品名称"></el-table-column>
      <el-table-column prop="categoryCode" label="小类编码"></el-table-column>
      <el-table-column prop="saleDate" label="销售时间">
        <template slot-scope="scope">
          <span>{{util.toDateString(new Date(scope.row.saleDate))}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="quantity" label="全国销售数量">
        <template slot-scope="scope">
          <span>{{util.formatMoney(scope.row.quantity, 2, '')}}{{scope.row.unit}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="quantity" label="全国销售额">
        <template slot-scope="scope">
          <span>{{util.formatMoney(scope.row.amount, 2, '￥')}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="price" label="全国销售平均售价">
        <template slot-scope="scope">
          <span>{{util.formatMoney(scope.row.price, 2, '￥')}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="profit" label="全国销售毛利额">
        <template slot-scope="scope">
          <span>{{util.formatMoney(scope.row.profit, 2, '￥')}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="profitRate" label="全国销售毛利率">
        <template slot-scope="scope">
          <span>{{util.formatMoney(scope.row.profitRate * 100, 2, '')}}%</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  name: "SupplyChainCommodity",
  props: ["code"],
  data() {
    return {
      loading: true,
      date: "",
      latestUpdateDate: undefined,
      pickerOptions: {
        disabledDate: this.disabledDate
      }
    };
  },
  computed: {
    retrieve() {
      const data = this.$store.state.sc.scSaleCommodity.retrieve;
      const time = this.$store.state.sc.scSaleCommodity.getSyncTime;
      if (!data) {
        this.loading = false;
        return {
          page: {
            totalCount: 0,
            numPerPage: 10,
            pageNum: 1
          },
          results: []
        };
      }
      if (data.results.length > 0) {
        this.loading = false;
        if (!this.latestUpdateDate) {
          this.latestUpdateDate = time && new Date(time);
        }
      }
      return data;
    }
  },
  created() {},
  methods: {
    onQuery() {
      this.$emit("query", this.date);
    },
    disabledDate(e) {
       return e.getTime() > this.latestUpdateDate && this.latestUpdateDate.getTime();
    }
  }
};
</script>

<style lang="less">
.el-tooltip__popper.is-dark {
  background: #f7faf8;
  color: #666;

  .popper__arrow {
    border-top-color: #f7faf8;
  }

  .popper__arrow::after {
    border-top-color: #f7faf8;
  }
}

.sc-table-header-right {
  float: right;
  text-align: right;

  .update-date {
    height: 14px;
    line-height: 14px;
    font-size: 14px;
    font-weight: bold;
    color: rgba(109, 114, 120, 1);
    vertical-align: top;
    margin-bottom: 10px;
  }

  .tips {
    height: 12px;
    line-height: 12px;
    font-size: 12px;
    color: #999;
    vertical-align: top;
    img {
      vertical-align: top;
      height: 12px;
      margin-right: 5px;
    }
  }
}

.sc-tip {
  width: 30px;
  vertical-align: top;
  // float: right;
  // margin-right: 250px;
}

.subtitle {
  .el-input__inner {
    height: 34px;
    line-height: 1;
  }
}

.sc-table {
  .my-header-cell {
    background: #94a49b;
    color: white;

    font-size: 12px;
    padding: 0;
    height: 40px;
    // text-align: center;
  }

  .my-row {
    // height: 40px;
  }

  .my-cell {
    padding: 0;
    height: 40px;
    font-size: 12px;
    // text-align: right;
  }

  .el-range-editor.el-input__inner {
    padding: 0 10px;
  }

  .el-button {
    padding: 9px 20px;
  }

  .el-button--primary {
    background-color: #1b994f;
    border-color: #1b994f;
  }

  .el-pagination {
    text-align: center;
    margin: 20px 0;
  }

  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #1b994f;
    border-color: #1b994f;
  }
}
</style>


<style lang="less" scoped>
.sc-table {
  width: 1100px;

  .title {
    margin: 20px 0;

    img {
      display: inline-block;
      width: 12px;
      height: 12px;

      margin-right: 10px;
    }

    div {
      display: inline-block;
      width: 120px;
      height: 28px;
      font-size: 20px;
      font-weight: 600;
      color: rgba(51, 51, 51, 1);
      line-height: 28px;
    }
  }

  .subtitle {
    padding: 10px 0;

    .statistics-date {
      width: 56px;
      height: 22px;
      font-size: 14px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      line-height: 22px;

      margin: 10px;
    }

    .button {
      margin-left: 10px;
    }
  }
}
</style>
